import React from 'react';
import { Card, Button, Dropdown } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const ButtonsView = ({
  id,
  airlineCustomerServiceEmail,
  crmState,
  showCloseClaimModal,
  onEdit,
  onAddTask,
  onManageDocuments,
  onGenerateLoa,
  onCheckWaiver
}) => (
  <Card.Content extra>
    <Button primary basic onClick={showCloseClaimModal} content="Close" />
    <Button primary onClick={onEdit} content="Edit" />
    <Button primary onClick={onAddTask} content="Add Task" />
    <Dropdown
      text="Contact"
      className="link button"
      style={{ backgroundColor: '#2185D0', color: 'white' }}
    >
      <Dropdown.Menu>
        <Dropdown.Item
          as={Link}
          to={`/claim/${id}/contact/pax`}
          text="Contact PAX"
        />
        <Dropdown.Item
          as={Link}
          to={`/claim/${id}/contact/airline`}
          disabled={!airlineCustomerServiceEmail}
          text="Contact Airline"
        />
      </Dropdown.Menu>
    </Dropdown>
    <Button primary onClick={onManageDocuments} content="Manage Documents" />
    {crmState === 'a4_checking_pax_attachments' && (
      <Button primary onClick={onGenerateLoa} content="Generate Loa" />
    )}
    {crmState === 'b3_waiver_signed' && (
      <Button primary onClick={onCheckWaiver} content="Check Waiver" />
    )}
  </Card.Content>
);

export default ButtonsView;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/ButtonsBlock/ButtonsView.js